import * as React from 'react';

import {
    Card,
    CardHeader,
    CardContent,
    FormControl,
    RadioGroup,
    FormControlLabel,
    Radio,
} from '@mui/material'

export default function Question({ question, options, selectedOption, handleOptionChange }) {
    // Mezclar las opciones de forma aleatoria
    const shuffledOptions = React.useMemo(() => shuffleArray(options), [options]);

    // Obtener el índice de la opción correcta (la primera opción del array original)
    const correctIndex = options.indexOf(options[0]);

    return (
        <Card sx={{marginBottom: 2}}>
            <CardHeader title={question.question} />
            <CardContent>
                <FormControl component="fieldset">
                    <RadioGroup value={selectedOption} onChange={ handleOptionChange}>
                        {shuffledOptions.map((option, index) => (
                            <FormControlLabel
                                key={index}
                                value={option}
                                control={<Radio color="primary" />}
                                label={option}
                            />
                        ))}
                    </RadioGroup>
                </FormControl>
            </CardContent>
        </Card>
    );
}

// Función para mezclar un array de forma aleatoria utilizando el algoritmo Fisher-Yates
function shuffleArray(array) {
    const shuffledArray = [...array];
    for (let i = shuffledArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
    }
    return shuffledArray;
}
